import React, { useContext } from 'react'
import { Translations } from '../services/TranslationService'
import { StateContext } from '../services/StateService'
import { trackPDPData } from '../services/TealiumService'
import Select from '@3mcom/mds-library/dist/node/Select'
import { createDefaultSelectorOpt } from '../services/PDPService'

const Selectors = () => {
    const translations = useContext(Translations)
    const { selectedOptions, dispatch, highlightSelectors } = useContext(StateContext)
    if (!selectedOptions?.options) return null
    return Object.keys(selectedOptions?.options)?.map((key, index) => {
        const selector = selectedOptions.options[key]
        const defaultOpt = createDefaultSelectorOpt(
            translations.all,
            selector?.selectedValue
        )

        if (!selector?.values || selector?.values.length === 1) return null

        const hasDefaultOpt = selector?.values?.some(
            (option) => option?.api === defaultOpt.api
        )
        const selectorWithDefault = {
            ...selector,
            values: hasDefaultOpt
                ? selector?.values
                : [defaultOpt].concat(selector?.values)
        }

        let className = ''
        if (!selectorWithDefault.selectedValue && !highlightSelectors) {
            className = 'sps2-pdp_pSelector--selectors_regular-gray-ring'
        } else if (selectorWithDefault.selectedValue) {
            className = 'sps2-pdp_pSelector--selectors_thick-black-ring'
        } else if (highlightSelectors) {
            className = 'sps2-pdp_pSelector--selectors_thick-red-ring'
        }

        return (
            <Select
                fieldName={selectorWithDefault?.label}
                id={`${index}_pSelector`}
                key={`${index}_pSelector`}
                selectLabel={selectorWithDefault?.label}
                disabled={selectorWithDefault.disabled}
                value={selectorWithDefault?.selectedValue || 'all'}
                onChange={(e) => {
                    dispatch({
                        type: 'pdp_on_change_selected_options',
                        payload: {
                            selector: selector,
                            target: e.target,
                            allLabel: translations.all
                        }
                    })
                    trackPDPData(
                        `PDP Buying Zone Product Selector ${selectorWithDefault.label} Click: ${selectorWithDefault?.selectedValue}`,
                        'Engagement Event'
                    )
                }}
                className={className}
            >
                {selectorWithDefault?.values?.map((value, i) => (
                    <option
                        disabled={value?.disabled}
                        className={
                            value?.disabled
                                ? 'sps2-pdp_pSelector--selectors_disabled'
                                : ''
                        }
                        key={`${i}_p-value`}
                        value={value?.api}
                        optionlabel={`${value?.value} ${value?.uom ? value.uom : ''}`}
                    >
                        {`${value?.value} ${value?.uom ? value.uom : ''}${
                            value?.disabled ? ` - ${translations.notApplicable}` : ''
                        }`}
                    </option>
                ))}
            </Select>
        )
    })
}

export default Selectors
